import React, { useContext } from 'react';
import { Tag, Flexer } from '@ontruck/orc';

import { FormatPrice } from 'utils/format';
import PrebookingAssignmentContext from 'modules/pre-booking/assignment/context';

import CardActions from './CardActions';

const t = {
  prio: 'Prio',
};

const HeaderInfo = ({ id }) => {
  const { prebookingsObject } = useContext(PrebookingAssignmentContext);

  const prebooking = prebookingsObject[id];

  if (!prebooking) {
    return null;
  }
  const { driver, is_prebooking_prio, carrier, total_net_full_prebooking_cost } = prebooking;

  const name = carrier?.name || driver?.name;

  return (
    <>
      <Flexer.Child mLeft="XS" data-testid="carrier_name">
        {name}
      </Flexer.Child>
      <Flexer.Child flex="1" mLeft="XS" data-testid="booking_prio">
        {is_prebooking_prio && (
          <Tag skin="priority" weight="bold" textTransform="uppercase">
            {t.prio}
          </Tag>
        )}
      </Flexer.Child>
      <Flexer.Child mLeft="XS" flex="0" data-testid="total_net_full_prebooking_cost">
        <FormatPrice currency={carrier.currency} value={total_net_full_prebooking_cost} />
      </Flexer.Child>
      <Flexer.Child mLeft="XS" flex="0">
        <Flexer.Parent>
          <Flexer.Child>
            <CardActions id={id} />
          </Flexer.Child>
        </Flexer.Parent>
      </Flexer.Child>
    </>
  );
};

export default HeaderInfo;
